import { useMemo } from 'react';
import { Card, CardContent } from '@mui/material';
import { Create, Form, Toolbar } from 'react-admin';
import { MissionInputs } from './MissionInputs';
import { useLocation } from 'react-router';
import type { AntennaId, MemberId, MissionSummary } from '@wwf/sdk';
import type { MissionInput } from '@domain/mission';
import { missionSummaryToDuplicateDefaults } from './missionDuplicateDefaults';

type MissionCreateLocationState = {
    antennaId?: string;
    contactId?: string;
    duplicateDefaults?: Partial<MissionInput>;
    record?: MissionSummary;
};

export const MissionCreate = () => {
    const location = useLocation();
    const state = location.state as MissionCreateLocationState | null;
    const defaultValues = useMemo((): Partial<MissionInput> => {
        if (state?.record) {
            return missionSummaryToDuplicateDefaults(state.record);
        }
        if (state?.duplicateDefaults) {
            return state.duplicateDefaults;
        }
        return {
            antennaId: (state?.antennaId ?? null) as AntennaId | null,
            contactId: (state?.contactId ?? null) as MemberId | null,
            sessions: [
                {
                    id: null,
                    label: null,
                    startDate: null,
                    endDate: null,
                    contactId: null,
                    sortOrder: 0,
                },
            ],
        };
    }, [state]);

    return (
        <Create actions={false} redirect="show" mutationMode="pessimistic">
            <Form defaultValues={defaultValues}>
                <Card>
                    <CardContent>
                        <MissionInputs />
                    </CardContent>
                    <Toolbar />
                </Card>
            </Form>
        </Create>
    );
};
